/** {@link https://github.com/schuettflix/order/pull/897#discussion_r1607873769 What `isKeyOf` is useful for} */
export const isKeyOf = <T extends object>(obj: T, key: string | number | symbol): key is keyof T => {
    return key in obj;
};
